import Disclosure from "../../utils/Disclosure.js";

class Accordion {
    constructor(element, options = {}) {
        this.el = element;
        this.items = this.el.querySelectorAll("[data-accordion-item]");
        this.itemPanels = this.el.querySelectorAll("[data-accordion-content]");
        this.disclosureItems = [];
        this.options = {
            ...options,
        };

        // Bail early - no accordion items.
        if (this.items.length < 1) {
            return;
        }

        this.init();
    }

    init() {
        this.items.forEach((item) => {
            const itemPanel = item.querySelector("[data-accordion-content]");

            if (item instanceof Element === false) {
                return;
            }

            const accordionDisclosure = new Disclosure(itemPanel, {
                animate: true,
                collapseOnOtherElementsExpand: this.itemPanels,
            });

            // set height to ensure initial transition works.
            accordionDisclosure.isExpanded
                ? (itemPanel.style.height = `${itemPanel.scrollHeight}px`)
                : (itemPanel.style.height = "0px");
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const accordionElements = document.querySelectorAll("[data-accordions]");

    accordionElements.forEach((element) => {
        new Accordion(element);
    });
});
